export default "/static/webpack/media/undraw_collaboration.819fb39f.svg";